import TableTemplate from "../TableTemplate/tableTemplate";
import {
  IPortfolioAggregateSearchParams,
  IPortfolioAggregateTableReport,
} from "../../Interfaces/portfolio";
import { CommonTableUI } from "../TableTemplate/common";
import { getPortfolioAggregaateTable } from "../../Requests/portfolioRequests";

interface IProps {
  refreshFlag: boolean;
  onFetchComplete: () => void;
}

const AggregateTable = ({ refreshFlag, onFetchComplete }: IProps) => {
  return (
    <TableTemplate<
      IPortfolioAggregateSearchParams,
      IPortfolioAggregateTableReport
    >
      getDataTable={getPortfolioAggregaateTable}
      TableUI={({ reports, sortingType, setSortingType, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          sortingType={sortingType}
          setSortingType={setSortingType}
          tableBoxClassName="!mx-0"
          refreshFlag={refreshFlag}
        />
      )}
      withSort
      onFetchComplete={onFetchComplete}
    />
  );
};

export default AggregateTable;
